<template>
  <div class="u-mr3 display-flex" >
    <div style="width: 200px; border-right: 1px solid #999999" class="u-pr2 display-inline-block">
        <span class="display-block value-title">Name</span>
        <span class="display-block u-mb2 u-text--success">{{color.name}}</span>
        <span class="display-block value-title">SCSS Variable name</span>
        <span class="display-block u-mb2 u-text--success">{{color.variable_name}}</span>
        <span class="display-block value-title">Slug</span>
        <span class="display-block u-text--success">{{color.slug}}</span>

    </div>
    <div style="border-right: 1px solid #999999">
        <ba-color-sample title="Default value" :color="colorDefaultValue"></ba-color-sample>
    </div>
    <div style="border-right: 1px solid #999999">
        <ba-color-sample title="Current value" :color="colorCurrentValue"></ba-color-sample>
    </div>
    <div>
        <ba-color-sample title="Selected value" :color="immediateValue"></ba-color-sample>
    </div>

    <div class="u-mr2 display-inline-block" style="width: 200px">
      <el-input v-model="immediateValue"></el-input>
      <div v-if="colorCurrentValue !== immediateValue" class="u-pt1 u-pl4">
          <el-button size="mini" @click="saveColor" :disabled="!immediateValue || !immediateValue.length">Save</el-button>
          <el-button size="mini" @click="innerValue = colorCurrentValue">Reset</el-button>
      </div>

    </div>

    <div class="u-mr2 display-inline-block">
      <el-color-picker v-model="innerValue" show-alpha @active-change="activeChange" ref="pickerRef"></el-color-picker>
    </div>

  </div>
</template>

<script>
  import BaColorSample from './ba-color-sample.component.vue'
  export default {
    name: 'ba-color-picker',
    props: ['color'],
    components: {
      'ba-color-sample': BaColorSample,
    },
    watch: {
      colorCurrentValue: {
        handler (value) {
          if (this.colorCurrentValue) this.immediateValue = this.colorCurrentValue
        },
        immediate: true
      },
      innerValue: {
        handler (innerValue) {
          if (this.innerValue) this.immediateValue = this.normalizeValue(innerValue)
        },
        immediate: true
      },
      immediateValue: {
        handler (immediateValue) {
          if (this.immediateValue) this.innerValue = this.normalizeValue(immediateValue)
        },
        immediate: true
      },
    },
    data () {
      return {
        innerValue: null,
        immediateValue: null,
      }
    },
    computed: {
      colorCurrentValue () {
        return this.normalizeValue(this.color.value)
      },
      colorDefaultValue () {
        return this.normalizeValue(this.color.default)
      }
    },
    methods: {
      saveColor () {
        this.$emit('updateColorSignal', {
          slug: this.color.slug,
          value: this.immediateValue
        })
      },
      removeSpaces (value) {
        if (!value) return value
        return value.replace(' ', '')
      },
      removeTrailingSemicolons (value) {
        if (!value) return value
        while (value.length && (value.charAt(value.length - 1) === ';')) {
          value = value.slice(0, -1)
        }
        return value
      },
      activeChange (value) {
        this.immediateValue = this.normalizeValue(value)
      },
      convertRGBaToHexIfPossible (value) {
        // here we will try to convert
        if (!value) return
        let cleanValue = this.removeSpaces(value)

        if (!cleanValue.length) return

        if (cleanValue.startsWith('rgb')) {
          // pure RGB value. Convert it to HEX
          const parts = value.replace(/rgba|rgb|\(|\)/gm, '')
            .split(/\s|,/g).filter((val) => val !== '').map((val, index) => index > 2 ? parseFloat(val) : parseInt(val, 10))
          if (parts.length === 4 || parts.length === 3) { // it's rgb(a), convert to hex
            let r = Math.round(parts[0])
            let g = Math.round(parts[1])
            let b = Math.round(parts[2])
            if ((parts.length === 4) && (parts[3] !== 1)) return cleanValue
            // here we could have RGB OR RGBA+a===1. That means it's simple RGB
            let rStr = r.toString(16)
            if (rStr.length === 1) rStr = `0${rStr}`
            let gStr = g.toString(16)
            if (gStr.length === 1) gStr = `0${gStr}`
            let bStr = b.toString(16)
            if (bStr.length === 1) bStr = `0${bStr}`
            return `#${rStr}${gStr}${bStr}`
          }
        } else return cleanValue
      },
      normalizeValue (value) {
        if (!value) return

        let cleanValue = this.removeSpaces(value)

        cleanValue = this.removeTrailingSemicolons(cleanValue)

        if (!cleanValue.length) return

        cleanValue = cleanValue.toLowerCase()

        if (cleanValue.startsWith('#')) {
          // it's HEX. Make sure it's 6 signs hex
          if (cleanValue.length === 7) return cleanValue
          if (cleanValue.length === 9) {
            // it's rgba as hex. convert to rgba to let picker work
            let r = parseInt(cleanValue.substring(1, 3), 16)
            let g = parseInt(cleanValue.substring(3, 5), 16)
            let b = parseInt(cleanValue.substring(5, 7), 16)
            let a = Math.round(100*parseInt(cleanValue.substring(7, 9), 16)/255)/100
            let rgbaStr = `rgba(${r},${g},${b}, ${a})`
            return this.convertRGBaToHexIfPossible(rgbaStr) // if a == 1 we will convert it back to hex
          }
          return
        }
        if (cleanValue.startsWith('rgb')) {
          return this.convertRGBaToHexIfPossible(cleanValue)
        }
      },
    },
    mounted () {
      // this is ugly watcher. Unfortunately have no other way to track if picker was closed
      this.$watch('$refs.pickerRef.showPicker', (newValue, oldValue) => {
        if (!newValue) {
          // picker closed
          this.immediateValue = this.normalizeValue(this.innerValue)
        }
      })
    }
  }
</script>

<style lang="css">
  .value-title {
    color: grey;
    font-size: 12px
  }
</style>
